<template>
  <div id="app">
    <template v-if="show=='def'">
      <headtop></headtop>
      <headerdescribe></headerdescribe>
    </template>
    <template v-if="show=='new'">
      <headnewtop></headnewtop>
    </template>
    <router-view v-if="isRouterAlive"/>
    <template v-if="show=='def'">
      <footbot></footbot>
    </template>
    <template v-if="show=='new'">
      <footnewbot></footnewbot>
    </template>
  </div>
</template>
<script>
import headtop from "@/views/common/header";
import footbot from "@/views/common/footer";
import headnewtop from "@/views/forum/head";
import footnewbot from "@/views/forum/foot";
import headerdescribe from "@/components/HeaderDescribe";

import {
  mapState,mapMutations
} from 'vuex'
export default {
  components: {
    headtop,
    footbot,
    headerdescribe,
    headnewtop,
    footnewbot
  },
  computed:{
    ...mapState({
      activeIndex:state=>state.activeIndex
    })
  
  },
  provide() {
    return {
      reload : this.reload,
    }
  },
  data(){
    return {
      show:'new',
      isRouterAlive:true
    }
  },
  watch:{
    $route: {
      //handler 方法就相当于普通侦听器触发的事件,即:当数据变化时要执行的操作
      handler: function (newV, oldV) {  
        console.log("val.nameval.nameval.nameval.name", newV.path);
        if(newV.path.indexOf('forum')>-1||newV.path.indexOf('newsnotice')>-1||newV.path.indexOf('generalassembly')>-1||newV.path.indexOf('newVideo')>-1||newV.path.indexOf('picture')>-1){
          this.show='new'
        }else{
          this.show='def'
          
        }
        // this.show='new'
        // this.curpath = newV.name;
      },
      immediate: true, //当监听的属性为一个对象的时候添加deep:true才可以起作用
    },
  },
  
  created() {
    // this.SETACTIVE(2)
    console.log(this.activeIndex,'activeIndexactiveIndexactiveIndex');
    // console.log(this.$postHttp);
  },
  methods:{
    ...mapMutations(['SETACTIVE']),
    // 通过声明reload方法，控制router-view的显示或隐藏，从而控制页面的再次加载
    reload(){
      this.isRouterAlive = false;
      var temp1 =  this.$store.state.actives 
      var temp2 =  this.$store.state.activeIndex 
      this.SETACTIVES(null)
      this.SETACTIVE(-1)
      this.$nextTick(() => {
        this.SETACTIVES(temp1)
        this.SETACTIVE(temp2)
        this.isRouterAlive = true;
      })
    },

  }
};
</script>


<style lang="less">

.pointer{
  cursor: pointer;
}
.text1{
  white-space: nowrap; 
overflow: hidden; 
text-overflow: ellipsis

}
.text1 p{
 
  white-space: nowrap; 
overflow: hidden; 
text-overflow: ellipsis

}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
}

a {
  text-decoration-line: none;
}

ul,
ul li,
ol,
li {
  list-style: none outside none;
}
ul,
ul li,
ol,
li {
  list-style: none outside none;
}
img {
  vertical-align: middle;
  border: none;
  width: 100%;
}
i {
  font: inherit;
}
input,
select,
option {
  vertical-align: middle;
  border-radius: 0px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  outline: none;
}
input[type="text"],
input[type="button"],
input[type="submit"],
input[type="reset"] {
  -webkit-appearance: none;
  appearance: none;
  border-radius: 0;
  outline: none;
}
.fl {
  float: left;
  display: inline;
}
.fr {
  float: right;
  display: inline;
}
h1,
h2,
h3,
h4,
h5,
h6,
i,
strong {
  font-weight: normal;
}
select::-ms-expand {
  display: none;
}
a {
  color: #fff;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
a:hover {
  text-decoration: none;
  outline: none;
}
.clear {
  clear: both;
}

/* .clearfix:after {content: ".";display: block;height: 0;clear: both;visibility: hidden;} */
/* .clearfix {zoom: 1;display: block;_height: 1px;clear: both;} */
body,
ul,
ol,
li,
p,
h1,
h2,
h3,
h4,
h5,
h6,
form,
fieldset,
table,
td,
img,
div,
dl,
dt,
dd,
input {
  margin: 0;
  padding: 0;
}

.headtitle {
  position: relative;
  font-size: 26px;
  font-family: PingFang SC-Regular, PingFang SC;
  color: #333333;
  font-weight: 500;
  padding-left: 20px;
  margin-left: 5px;
  margin-top: 6px;
  margin-bottom: 25px;
  &:before {
    position: absolute;
    content: "";
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 24px;
    background: #6f73f4;
    border-radius: 2px 2px 2px 2px;
  }
}
.boxs {
  font-size: 22px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 50px;
  margin-bottom: 60px;
}
</style>
